/*
  CodeField.jsx
*/

// Npm.
import React from 'react';

// Makes.
import { makeStyles, cx } from '../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'transparent',
    color: 'inherit',
    width: '100%',
    border: `1px solid ${theme.color_divider}`,
    borderRadius: 4,
    padding: 4,
    resize: 'vertical',
    height: 320,
    minHeight: 320,
    maxHeight: 512,
  }
}));

/**
 * Textarea for showing code. Purely for CSS styling.
 */
export default function CodeField({ className, ...rest }) {

  const classes = useStyles();

  return (
    <textarea className={cx(classes.root, className)} {...rest} />
  );
}
